import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import { TooltipWrapper } from 'components/Tooltip/Tooltip'

import { isBlockArticleType } from 'common/utils/isBlockArticleType.js'
import { isSubscriptionExpired } from 'common/utils/permissions.js'

import { EditPencilIcon, IconDuplicate, OpenInNewWindow, StatsIcon } from 'svg'

import { MODAL_TYPES } from '../../../../modals/ModalController.jsx'

import './ActionButtons.scss'

const ActionButtons = ({
    isPublished,
    project,
    isCanManageProject,
    onOpenModal,
    onEditProject,
    onDuplicateProject,
    isLoading,
}) => {
    const { t } = useTranslation()

    const isMin1600 = useMediaQuery({ minWidth: 1600 })
    const isMax1340 = useMediaQuery({ maxWidth: 1340 })

    const isHiddenTooltips = isMin1600 || isMax1340

    const getPublicUrl = _item => {
        if (_item.projectVersions && _item.projectVersions.length) {
            return _item.projectVersions[0].publicUrl
        }
        return ''
    }

    return (
        <ul className="project-block__buttons-view">
            {isPublished && (
                <>
                    <li>
                        <TooltipWrapper tooltipText={t('View project')} isHidden={isHiddenTooltips}>
                            <a
                                href={getPublicUrl(project)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`button-style is-hidden-text ${isLoading ? 'is-loading' : ''}`}
                                data-size="md"
                                data-variant="secondary"
                            >
                                <span className="project-block__buttons-view-icon">
                                    <OpenInNewWindow isLoading={isLoading} />
                                </span>
                                {t('View project')}
                            </a>
                        </TooltipWrapper>
                    </li>
                    {isBlockArticleType(project.projectType.projectType) && (
                        <li>
                            <TooltipWrapper tooltipText={t('Statistics')} isHidden={isHiddenTooltips}>
                                <Link
                                    to={isSubscriptionExpired() ? '#' : `/my-projects/${project.projectId}/analytics`}
                                    className={`button-style is-hidden-text ${isLoading ? 'is-loading' : ''}`}
                                    data-size="md"
                                    data-variant="secondary"
                                    data-test="view-detail-stats"
                                    onClick={
                                        isSubscriptionExpired()
                                            ? evt => onOpenModal(MODAL_TYPES.subscriptionExpired, project, evt)
                                            : null
                                    }
                                >
                                    <span className="project-block__buttons-view-icon">
                                        <StatsIcon isLoading={isLoading} />
                                    </span>
                                    {t('Statistics and leads')}
                                </Link>
                            </TooltipWrapper>
                        </li>
                    )}
                </>
            )}

            {isBlockArticleType(project.projectType.projectType) && (
                <li>
                    {isCanManageProject ? (
                        <button
                            className={`button ${isLoading ? 'is-loading' : ''}`}
                            data-size="md"
                            data-variant="secondary"
                            data-test="edit-project"
                            onClick={evt => onEditProject(project, evt)}
                        >
                            <span className="project-block__buttons-view-icon">
                                <EditPencilIcon isLoading={isLoading} />
                            </span>
                            {t('Edit')}
                        </button>
                    ) : (
                        <button
                            className={`button ${isLoading ? 'is-loading' : ''}`}
                            data-size="md"
                            data-variant="secondary"
                            onClick={evt => onDuplicateProject(project, evt)}
                        >
                            <span className="project-block__buttons-view-icon">
                                <IconDuplicate isLoading={isLoading} />
                            </span>
                            {t('Clone')}
                        </button>
                    )}
                </li>
            )}
        </ul>
    )
}

export default ActionButtons
